<template>
  <div class="rd-month">
    <div class="rd-detail__body">
      <div class="rd-month-nav">
        <button type="button" class="ui-icon-btn ui-icon-btn--sm" :aria-label="$t('report_mobile.prev_month')" @click="stepMonth(-1)">
          <v-icon size="18">mdi-chevron-left</v-icon>
        </button>
        <div class="rd-month-nav__title" aria-live="polite">
          {{ monthTitle }}
          <small v-if="monthHint">{{ monthHint }}</small>
        </div>
        <button type="button" class="ui-icon-btn ui-icon-btn--sm" :aria-label="$t('report_mobile.month_next')" @click="stepMonth(1)">
          <v-icon size="18">mdi-chevron-right</v-icon>
        </button>
      </div>

      <div class="rd-stats rd-stats--pair">
        <div class="ui-stat ui-stat--inverse">
          <span class="ui-stat__label">{{ $t("orders") }}</span>
          <span class="ui-stat__value">{{ orders.length }}</span>
        </div>
        <div class="ui-stat">
          <span class="ui-stat__label">{{ $t("spent_on_credits") }}</span>
          <span class="ui-stat__value">{{ money(creditsTotal) }}</span>
        </div>
      </div>

      <div v-if="loading" class="rd-skeleton" style="height: 220px"></div>
      <div v-else-if="failed" class="rd-alert ui-banner ui-banner--lg" role="alert">
        <v-icon size="22" color="#7a1b13">mdi-alert-outline</v-icon>
        <div>
          <b>{{ $t("report_mobile.load_failed") }}</b>
          <button type="button" class="ui-btn ui-btn--sm rd-state__retry" @click="load">
            {{ $t("report_mobile.retry") }}
          </button>
        </div>
      </div>

      <ul v-else-if="orders.length" class="rd-days">
        <li v-for="order in orders" :key="order.id" class="rd-day">
          <span class="rd-day__tile is-ordered">
            <b class="rd-num">{{ order.day }}</b>
            <span>{{ order.weekday }}</span>
          </span>
          <span>
            <span class="rd-day__meal">{{ order.items || "–" }}</span>
            <span class="rd-day__meta">{{ order.meta }}</span>
          </span>
        </li>
      </ul>
      <div v-else class="rd-empty rd-empty--tight">
        <b>{{ $t("report_mobile.no_orders_month") }}</b>
      </div>
    </div>
  </div>
</template>

<script>
import hasCreditUserMonth from "../../../shared/more/hasCreditUserMonth";

/**
 * Kreditni korisnik (firme "više restorana") u panelu: narudžbe izabranog meseca sa iznosom i potrošenim
 * kreditom (isti podaci kao stari dijalog: /credits/report). Mesec kreće od kraja izabranog perioda.
 */
export default {
  name: "ReportDesktopCreditUser",
  mixins: [hasCreditUserMonth],
  props: {
    /** Red iz izveštaja: { user_id, user_name } */
    user: { type: Object, required: true },
    companyId: { type: [Number, String], default: null },
  },
};
</script>
